import React from 'react';
import { RouteObject } from 'react-router-dom';
import MainLayout from '../components/layout/MainLayout';
import OfficialsList from '../components/officials/OfficialsList';
import ActsList from '../components/acts/ActsList';
import ProtectedRoute from './ProtectedRoute';

// Import pages (to be created)
const Home = React.lazy(() => import('../pages/Home'));
const OfficialDetails = React.lazy(() => import('../pages/OfficialDetails'));
const ActDetails = React.lazy(() => import('../pages/ActDetails'));
const SubmitAct = React.lazy(() => import('../pages/SubmitAct'));
const Login = React.lazy(() => import('../pages/auth/Login'));
const Register = React.lazy(() => import('../pages/auth/Register'));
const NotFound = React.lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'officials',
        children: [
          {
            index: true,
            element: <OfficialsList />,
          },
          {
            path: ':id',
            element: <OfficialDetails />,
          },
        ],
      },
      {
        path: 'acts',
        children: [
          {
            index: true,
            element: <ActsList />,
          },
          {
            path: ':id',
            element: <ActDetails />,
          },
          {
            path: 'submit',
            element: (
              <ProtectedRoute>
                <SubmitAct />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: 'auth',
        children: [
          {
            path: 'login',
            element: <Login />,
          },
          {
            path: 'register',
            element: <Register />,
          },
        ],
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

export default routes;